import Component from "@ember/component"
import { inject as service } from "@ember/service"

export default class AdminSidebarAction extends Component {
  @service("ember-store")
  store

  @service
  rpc

  canShowActionMenu = false
}
